import { Component, Input, OnInit } from '@angular/core';
import { NavigationParams } from "../../app/app.interfaces";



@Component({
  selector: 'back-button',
  templateUrl: 'back-button.html'
})

export class BackButton implements OnInit {
  
  @Input() navigationParams: NavigationParams  = {
    shortcut: 'back'
  };

  @Input() inHeaderBarMobile? : boolean = false;


	ngOnInit(): void {
    this.navigationParams.pop = true;
  }
  
}



// WEBPACK FOOTER //
// ./src/partials/back-button/back-button.ts